import { HttpClient, provideHttpClient, withFetch } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule, provideClientHydration } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideTranslateService, TranslateDirective, TranslateLoader, TranslatePipe } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import { BsDropdownModule } from 'ngx-bootstrap/dropdown';
import { ClipboardModule } from 'ngx-clipboard';
import { CarouselModule } from 'ngx-owl-carousel-o';

import { ModalModule } from 'ngx-bootstrap/modal';
import { ToastrModule } from 'ngx-toastr';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { BannerComponent } from './components/banner/banner.component';

import { FooterComponent } from './components/footer/footer.component';
import { HeaderComponent } from './components/header/header.component';
import { HomeComponent } from './components/home/home.component';
import { LanguageComponent } from './components/language/language.component';
import { RoundAndUserDetails } from './components/round-and-user-details/round-user-details.component';
import { ScrollerComponent } from './components/scroller/scroller.component';
import { StakingComponent } from './components/staking/staking.component';
import { SwapComponentV2 } from './components/swap-v2/swap-v2.component';
import { SwapComponent } from './components/swap/swap.component';
import { WidgetV1 } from './components/widget-v1/widget-v1.component';
import { WidgetV2 } from './components/widget-v2/widget-v2.component';
import { BestwalletComponent } from './modals/bestwallet/bestwallet.component';
import { ClaimComponent } from './modals/claim/claim.component';
import { ConnectComponent } from './modals/connect/connect.component';
import { NoWalletComponent } from './modals/no-wallet/no-wallet.component';
import { ReferComponent } from './modals/refer/refer.component';
import { WertComponent } from './modals/wert/wert.component';
import { SharedModule } from './shared/shared.module';
import { BuyETHWertComponent } from './modals/eth-buy-wert/buy-eth-wert.component';
import { AboutUsComponent } from './components/about-us/about-us.component';
import { FeatureComponent } from './components/feature/feature.component';
import { ClaimWidgetComponent } from './components/claim-widget/claim-widget.component';
import { ClaimPageComponent } from './components/claim-page/claim-page.component';

@NgModule({
  declarations: [
    AppComponent,
    BannerComponent,
    SwapComponent,
    SwapComponentV2,
    HomeComponent,
    HeaderComponent,
    FooterComponent,
    LanguageComponent,
    NoWalletComponent,
    ConnectComponent,
    ClaimComponent,
    ReferComponent,
    WertComponent,
    ScrollerComponent,
    ClaimPageComponent,
    ClaimWidgetComponent,
    StakingComponent,
    BestwalletComponent,
    RoundAndUserDetails, // This component is used to show the Round timer, User purchased details, Round title etc
    WidgetV1, // This widget is uses the old Buy flow. Uses ETH, USDT and Card Tabs,
    WidgetV2, // This widget uses new buy flow. Buy with Card and Buy with Crypto,
    BuyETHWertComponent,
    AboutUsComponent,
    FeatureComponent
  ],
  imports: [
    BrowserModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    FormsModule,
    AppRoutingModule,
    NgxChartsModule,
    SharedModule,
    TranslatePipe,
    TranslateDirective,
    CarouselModule,
    AccordionModule,
    ClipboardModule,
    ModalModule.forRoot(),
    AngularSvgIconModule.forRoot(),
    BsDropdownModule.forRoot(),
    ToastrModule.forRoot({
      timeOut: 4000,
      positionClass: 'toast-bottom-right',
      preventDuplicates: true,
      disableTimeOut: false,
      progressBar: true,
      progressAnimation: 'decreasing',
      maxOpened: 1,
    }),
  ],
  providers: [
    provideHttpClient(withFetch()),
    provideTranslateService({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    provideClientHydration(),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
export function HttpLoaderFactory(http: HttpClient): TranslateHttpLoader {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
